// extracted by mini-css-extract-plugin
export default {"log_table_pager_container":"LogTablePager_log_table_pager_container__LuxA-","active":"LogTablePager_active__Q8wtj"};